import type {DwollaClient} from "../components/paymentMethods/processors/DwollaService";

// Global window type extensions
declare global {
  interface Window {
    Plaid?: unknown;
    dwolla?: DwollaClient;
  }
}

const PLAID_LINK_SRC = 'https://cdn.plaid.com/link/v2/stable/link-initialize.js';
let plaidScriptLoad: Promise<void> | undefined;

/**
 * Loads Plaid Link on demand. Concurrent callers share one in-flight request so the
 * script is only injected once. A failed load
 * rejects and clears the cache so the next call can retry.
 */
export const loadPlaidScript = (): Promise<void> => {
  if (window.Plaid) {
    return Promise.resolve();
  }
  if (!plaidScriptLoad) {
    plaidScriptLoad = new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.onload = () => resolve();
      script.onerror = () => {
        plaidScriptLoad = undefined;
        script.remove();
        reject(new Error('Could not load Plaid Link. Please try again later.'));
      };
      script.src = PLAID_LINK_SRC;
      document.head.appendChild(script);
    });
  }
  return plaidScriptLoad;
};
